module.exports = __webpack_public_path__ + "img/planBG.2b4dce3c.png";